/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useState } from "react";
import { Formik, Form } from "formik";
import TextInput from "../../../common/formElements/TextInput";
import { Box, Button, Grid } from "@mui/material";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { create as createCustomGroup } from "./../../../store/customGroup/actions";
import { Data } from "./../../../store/customGroup/types";
import { Alert } from "@mui/lab";

interface CustomGroupAdd {
  setSubmitStatus?: () => void;
  closeDialog?: () => void;
}

const validateSchema = Yup.object().shape({
  name: Yup.string().required("Group Name is required and must be unique"),
});

const initialValues = { name: "", groupId: 0 } as Data;

const CustomGroupAdd = ({ setSubmitStatus, closeDialog }: CustomGroupAdd) => {
  const dispatch = useDispatch();
  const [error, setError] = useState<string | null>(null);

  const handleOnSave = async (values: Data) => {
    const result = await dispatch(
      // @ts-ignore
      createCustomGroup({
        ...values,
        groupId: parseInt(values.groupId as unknown as string),
      })
    );

    // @ts-ignore
    if (result.payload.data) {
      setError(null);
      setSubmitStatus && setSubmitStatus();
      closeDialog && closeDialog();
    } else {
      // @ts-ignore
      setError(result.payload[0].title); // err msg
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleOnSave}
      validationSchema={validateSchema}
    >
      {() => (
        <Form>
          {error && (
            <Box marginBottom={3}>
              <Alert severity="error">{error}</Alert>
            </Box>
          )}
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextInput fieldname="name" label="Group Name" required />
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Box mt={2} textAlign="center">
              <Button
                type="submit"
                color="primary"
                variant="contained"
                size="large"
                style={{ marginRight: 15 }}
              >
                Save
              </Button>
              <Button variant="outlined" size="large" onClick={closeDialog}>
                Cancel
              </Button>
            </Box>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default CustomGroupAdd;
